import { Button } from '@/components/ui/button';
import type { MappedOrderGraphData } from '@/models/graphs';
import type { ColumnDef } from '@tanstack/vue-table';
import { ArrowUpDown } from 'lucide-vue-next';
import { h } from 'vue';

export const paymentPlanAnalysisColumns: ColumnDef<MappedOrderGraphData>[] = [
  {
    accessorKey: 'name',
    header: ({ column }) => {
      return h(
        Button,
        {
          class: '!p-0',
          variant: 'ghost',
          onClick: () => column.toggleSorting(column.getIsSorted() === 'asc'),
        },
        () => ['Month', h(ArrowUpDown, { class: 'ml-2 h-4 w-4' })],
      );
    },
    cell: ({ getValue }) => getValue(),
  },
  {
    accessorKey: 'Placed',
    header: () => h('div', { class: 'text-right' }, 'Placed'),
    cell: ({ getValue }) => {
      return h('div', { class: 'text-right' }, getValue() as number);
    },
  },
  {
    accessorKey: 'Completed',
    header: () => h('div', { class: 'text-right' }, 'Completed'),
    cell: ({ getValue }) => {
      return h('div', { class: 'text-right' }, getValue() as number);
    },
  },
  {
    accessorKey: 'Cancelled',
    header: () => h('div', { class: 'text-right' }, 'Cancelled'),
    cell: ({ getValue }) => {
      return h('div', { class: 'text-right' }, getValue() as number);
    },
  },
];
